<!-- Scrim below the top bar; clicking it closes via the document click listener. -->
<div
    aria-hidden="true"
    [class.opacity-100]="isSidebarOpen()"
    [class.opacity-0]="!isSidebarOpen()"
    [class.pointer-events-none]="!isSidebarOpen()"
    class="fixed top-(--top-bar-height) left-0 z-[998] h-[calc(100vh-var(--top-bar-height))] w-screen bg-[rgba(15,23,42,0.4)] transition-opacity duration-200 dark:bg-[rgba(0,0,0,0.5)]"
></div>

<div
    #sidebarElement
    id="sidebar"
    [class.translate-x-0]="isSidebarOpen()"
    class="border-surface fixed top-(--top-bar-height) left-0 z-[999] flex h-[calc(100vh-var(--top-bar-height))] w-[320px] -translate-x-full transform flex-col border-r bg-(--p-content-background) px-[8px] transition-transform duration-200 ease-in-out select-none"
>
    <div class="sticky top-0 z-10 bg-(--p-content-background) pt-[10px] pb-[8px]">
        <div
            class="flex h-9 items-center overflow-hidden rounded-md border border-(--p-form-field-border-color) bg-(--p-form-field-background) transition-[border-color,box-shadow] duration-200 focus-within:border-(--p-primary-color) focus-within:shadow-[0_0_0_3px_rgba(0,114,195,0.14)]"
        >
            <span class="material-symbols-outlined shrink-0 pl-2 text-[1.25rem]/tight! text-(--p-surface-400)">search</span>
            <input
                #sidebarSearchInput
                class="min-w-0 flex-1 border-0! bg-transparent! px-2 py-0 text-[0.95rem] shadow-none! outline-none placeholder:text-(--p-surface-400)"
                [value]="sidebarSearchTerm()"
                (input)="onSearchTermInput($event)"
                (keydown)="onSearchInputKeyDown($event)"
                type="text"
                pInputText
                placeholder="Go to..."
            />
            @if (sidebarSearchTerm()) {
                <button
                    type="button"
                    class="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-(--p-text-muted-color) hover:bg-(--p-navigation-item-focus-background) hover:text-(--p-text-color)"
                    (click)="onSearchCleared()"
                >
                    <span class="material-symbols-outlined text-[17px]/none!">close</span>
                </button>
            }
        </div>
    </div>

    <div class="min-h-0 flex-1 overflow-auto pb-[8px]">
        <app-sidebar-shortcuts />

        <!-- A hairline divider precedes each section: search/shortcuts → home → domains → admin. -->
        @for (sectionItems of visibleSections(); track $index) {
            <div class="mx-[1px] my-[4px] h-px shrink-0 bg-(--p-content-border-color)"></div>
            <ul class="flex flex-col gap-[2px]">
                @for (sidebarItem of sectionItems; track $index) {
                    <li>
                        <app-sidebar-item [sidebarItem]="sidebarItem" [isRoot]="true"></app-sidebar-item>
                    </li>
                }
            </ul>
        }

        @if (isSearching() && visibleSections().length === 0) {
            <div class="px-3 py-4 text-sm text-(--p-text-muted-color)">No menu items found.</div>
        }
    </div>

    @if (isSearching()) {
        <div class="flex h-[28px] shrink-0 items-center border-t border-(--p-content-border-color) px-[9px] text-[0.6875rem] text-(--p-surface-400) dark:text-(--p-surface-500)">↑↓ navigate · Enter open · Esc close</div>
    }
</div>
